export enum PortfolioSortingTypes {
  ALPH = 'ALPH',
  PNL = 'PNL',
  POSITION = 'POSITION',
}
